import { setDoc, doc } from 'firebase/firestore';
import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { db } from '../../firebaseConfig';
import { Box, Button, Container, Typography } from '@mui/material';

const BuyProduct = () => {
    const { userId, prodId } = useParams();
    const navigate = useNavigate();
    const { product } = useLocation().state;

    const handleProceed = async () => {
        const confirmPurchase = window.confirm('Are you sure you want to purchase this product?');
        if (confirmPurchase) {
            const orderId = `${prodId}${userId}`;
            const orderRef = doc(db, 'order', orderId);
            await setDoc(orderRef, {
                id: orderId,
                stage: 'To start',
                product: product,
                userId: userId,
            });

            navigate(`/store/${userId}/${prodId}/track`, { state: { product } });
        }
    };

    return (
        <Container sx={{ mt: 4  }}>
            <Typography variant="h4" align="center" gutterBottom>
                Buy {product.badge}
            </Typography>
            <Box sx={{ textAlign: 'center', mb: 4, border:"0px solid black", paddingY:5, backgroundColor:"#EBECF6" }}>
                <img 
                    src={product.img} 
                    alt={product.badge} 
                    style={{margin:"auto" ,maxWidth: '100%', height: 'auto', borderRadius: '8px' }} 
                />
                <Typography variant="h6" sx={{ mt: 2 }}>Price: ${product.price}</Typography>
                <Typography variant="h6">Total Amount: ₹{product.price}</Typography>
            </Box>
            <Box textAlign="center">
                <Button variant="contained" color="primary" onClick={handleProceed}>
                    Proceed to Purchase
                </Button>
            </Box>
        </Container>
    );
};

export default BuyProduct;
